module.exports = __webpack_public_path__ + "static/media/ANM019-Cameron-Shafii05.1af5d918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ANM019-Cameron-Shafii05.jpg
// module id = 98
// module chunks = 0